<template>
    <v-app id="dashboard">
        <ConfirmDialog />
        <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
            <v-list dense nav>
                <template v-for="item in items">
                    <v-row
                            v-if="item.heading"
                            :key="item.heading"
                            align="center"
                    >
                        <v-col cols="6">
                            <v-subheader v-if="item.heading">
                                {{ item.heading }}
                            </v-subheader>
                        </v-col>
                        <v-col
                                cols="6"
                                class="text-center"
                        >
                        </v-col>
                    </v-row>
                    <v-list-group
                            v-else-if="item.children"
                            :key="item.text"
                            v-model="item.model"
                            :prepend-icon="item.model ? item.icon : item['icon-alt']"
                            append-icon=""
                    >
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ item.text }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item
                                v-for="(child, i) in item.children"
                                :key="i"
                                link
                                :to="child.href"
                        >
                            <v-list-item-action v-if="child.icon">
                                <v-icon>{{ child.icon }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ child.text }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                    <v-list-item
                            v-else
                            :key="item.text"
                            link
                            :to="item.href"
                    >
                        <v-list-item-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.text }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list>
        </v-navigation-drawer>
        <v-app-bar
                :clipped-left="$vuetify.breakpoint.lgAndUp"
                app
                color="blue darken-3"
                dark
                :hide-on-scroll="true"
        >
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
            <v-toolbar-title
                    style="width: 400px"
                    class="ml-0 pl-4"
            >
                <span class="hidden-sm-and-down">
                <router-link :to="{ name: 'Dashboard'}">
                    <v-img link max-width="150" cover src="../assets/UIT_logo-weisser.png" />
                </router-link>
            </span>
            </v-toolbar-title>
        </v-app-bar>
        <v-content>
            <v-container fluid class="sallysBackground">
                <v-row v-show="$route.name == 'Dashboard'">
                    <v-col>
                        <!--<D3BarChart :config="chartConfigLastSevenDays"
                                    :datum="charts.viewsLastThirtyDays"
                                    :title="chartTitleThirtyDays"
                                    :source="chartSource"
                        ></D3BarChart>
                        <D3WordsCloud :config="chartWordCloudConfig" :datum="charts.allTags"></D3WordsCloud>-->
                    </v-col>
                </v-row>
                <v-row v-if="currentRoute == 'Dashboard'">
                    <v-col class="col-lg-5 col-md-5 col-sm-12">
                        <!--<D3BarChart :config="chartConfigLastSevenDays"
                                    :datum="charts.viewsLastSevenDays"
                                    :title="chartTitleSevenDays"
                                    :source="chartSource"
                        ></D3BarChart>-->
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col class="col-lg-5 col-md-5 col-sm-12">

                    </v-col>
                </v-row>
                <router-view></router-view>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
  import configsys from "../conf";
  //import { D3WordsCloud } from 'vue-d3-charts';
  import ConfirmDialog from './ConfirmDialog'

  export default {
    beforeCreate () {
      //this.$store.dispatch('fetchCategories');
      //this.$store.dispatch('fetchStats');
    },
    beforeMount () {
      this.currentRoute = this.$route.name;
      this.chartSource = window.location.hostname;
    },
    mounted () {
      this.charts = this.$store.getters.getCharts;
    },
    components:{
      //D3BarChart,
      //D3WordsCloud,
      ConfirmDialog
    },
    data: () => {
        return {
          chartTitleSevenDays: 'Views letzten 7 Tage',
          chartTitleThirtyDays: 'Views letzten 30 Tage',
          height:500,
          chartSource: '',
          charts:{},
          currentRoute: '',
          drawer: null,
          items: configsys.routes,
          chartConfigLastSevenDays: {
            key: 'display_date',
            values: ['views']
          },
          chartWordCloudConfig: {
            angle: { start: 0, end: 90, steps: 2 },
            fontFamily: "monospace",
            margin: {
              top: 20,
              right: 20,
              bottom: 20,
              left: 20,
            },
          }
        };
    }
  }
</script>

<style scoped>
    .v-application .blue.darken-3{
        background-color: #E6007E !important;
        border-color: #E6007E !important;
    }

    .sallysBackground{
        height:100%;
        background: url(~@/assets/sallys_logo_welt.png) no-repeat;
        background-position: center;
    }
</style>